var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ibox" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "ibox-content table-responsive" }, [
      _c("table", { staticClass: "table table-hover no-margins" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.agentes, function (agente, index) {
            return _c("tr", { key: index }, [
              _c("td", [_c("small", [_vm._v(_vm._s(agente.estado))])]),
              _vm._v(" "),
              _c("td", [
                _vm._v(_vm._s(agente.nombres + " " + agente.apellidos)),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(agente.email))]),
              _vm._v(" "),
              _c("td", [
                !_vm.agentesPusher.includes(parseInt(agente.id))
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-outline btn-danger dim",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.cerrarSesion(agente.id)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-sign-out" }),
                        _vm._v(" Cerrar Sesion"),
                      ]
                    )
                  : _vm._e(),
              ]),
            ])
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [_vm._v("Agentes conectados")]),
      _vm._v(" "),
      _c("div", { staticClass: "ibox-tools" }, [
        _c("a", { staticClass: "collapse-link" }, [
          _c("i", { staticClass: "fa fa-chevron-up" }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Estado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Agente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Correo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Opciones")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }